
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"124","height":"124","fill":"#3D2562","rx":"16"}}),_c('g',{attrs:{"transform":"rotate(-90 62 28)"}},[_c('rect',{attrs:{"width":"56","height":"12","fill":"#7E5FDD","rx":"3"}}),_c('rect',{attrs:{"width":"56","height":"12","y":"22","fill":"#7E5FDD","rx":"6"}}),_c('rect',{attrs:{"width":"56","height":"12","y":"44","fill":"#7E5FDD","rx":"3"}}),_c('g',{attrs:{"fill":"#FFF"}},[_c('rect',{attrs:{"width":"40","height":"12","rx":"3"}}),_c('rect',{attrs:{"width":"56","height":"12","y":"22","rx":"3"}}),_c('rect',{attrs:{"width":"24","height":"12","y":"44","rx":"3"}})])])])])
          )
        }
      }
    